import { getEnvironment } from "../../config/environment";

export const isEnvironment = (...environments: string[]): boolean => {
  const environment = getEnvironment();
  return environments.includes(environment);
};
